module.exports = __webpack_public_path__ + "static/media/gift-card.eab101ad.svg";